import React, { useState } from "react";

const CheckBox = ({ model, nestedModel, field, label }) => {
  const [inputCheck, setInputCheck] = useState(false);
  const [value, setValue] = useState(0);

  const handleInputChange = () => {
    const newCheck = !inputCheck;
    newCheck ? setValue(1) : setValue(0);
    setInputCheck(newCheck);
  };
  return (
    <div className="my-5">
      <input
        type="hidden"
        value={value}
        checked={inputCheck}
        onChange={() => handleInputChange()}
        name={`${nestedModel}[${model}][${field}]`}
      />
      <p className="text-orange-500 font-bold text-base">
        <input
          type="checkbox"
          name={`${nestedModel}[${model}][${field}]`}
          className="mt-1 mr-1"
          checked={inputCheck}
          onChange={() => handleInputChange()}
        />
        {label}
      </p>
    </div>
  );
};

export default CheckBox;
